import { app } from '../../../../app';

app.factory('DropboxProvisioningService', DropboxProvisioningService);

/** @ngInject */
function DropboxProvisioningService($resource) {
    var rootUrl = 'app/rest/admin/company/:companyId/application/:appId/manageapp/dropboxprovisioning';

    return {       
        provisioningConfiguration : $resource(rootUrl,{},{ 
            'updateProvisioningConfiguration' : {
            method : 'PUT',
        }
        }),
        dropboxSync : $resource(rootUrl+'/dropboxGroups',{}),
        mappingSettings : $resource(rootUrl+'/mapping/settings',{},{ 
            'update' : {
            method : 'PUT',
        }
        }),
        groupMapping : $resource(rootUrl+'/mapping/remove',{},{ 
            'remove' : {
            method : 'PUT',
        }
        }),
        syncMapping : $resource(rootUrl+'/mapping/sync'),
        provMapping : $resource(rootUrl+'/mapping/prov'),
        automap : $resource(rootUrl+'/automap'),
        provisionNow : $resource(rootUrl+'/provision'),
        syncNow : $resource(rootUrl+'/sync')
       
    }
    

}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/dropbox-provisioning/dropbox-provisioning.service.js